import { Dialog, Sheet } from "@gravity-ui/uikit";

import { ChangeUserDataContent } from "../ChangeUserDataContent";

interface ChangeUserDataSheetProps {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  hasPhone?: boolean;
}

export const ChangeUserDataSheet = ({
  open,
  isLoading,
  onClose,
  hasPhone,
}: ChangeUserDataSheetProps) => {
  return (
    <Sheet visible={open} onClose={onClose}>
      <Dialog.Body>
        <ChangeUserDataContent
          isLoading={isLoading}
          onClose={onClose}
          hasPhone={hasPhone}
        />
      </Dialog.Body>
    </Sheet>
  );
};
